import type * as state from '../../../../../../../state'

export interface State {
  readonly orgChartId?: state.summit.orgChart.models.OrgChart.Id
}
export namespace State {
  export const INITIAL: Readonly<State> = {}
}
